import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FAQListItem } from "../../content.types";

export const requestFaqItems = async (
  params: GetListRequestParams
): Promise<GetListResponse<FAQListItem>> => {
  return await instance.get(ApiRoutesContent.FAQItems, { params });
};
